import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  Dropdown,
  ButtonGroup,
  Modal,
} from "react-bootstrap";
import { IoEye } from "react-icons/io5";
import { VscDiffAdded } from "react-icons/vsc";
import { FaEdit } from "react-icons/fa";
import { FcApproval } from "react-icons/fc";
import { TbCalendarCancel } from "react-icons/tb";
import { Link } from "react-router-dom";
import "./total-leave.css"; // Ensure you have this file to include the new styles
import LeaveLayout from "../../components/LeaveLayout.jsx"; // Corrected import
import axios from '../../Authservices/axiosInstance';

export default function TotalLeave() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [totalEntries, setTotalEntries] = useState(0);
  const [leaves, setLeaves] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success"); // success or error
  const [searchQuery, setSearchQuery] = useState(""); // State for the search query
  const [limit] = useState(10); // Limit per page

  // Fetch all leaves when the component mounts or when currentPage or searchQuery changes
  const fetchLeaves = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `https://backend.ems.uk.hiradentallab.com/api/leaves/leaves?search=${searchQuery}&page=${currentPage}&limit=${limit}`
      );
      setLeaves(response.data.leaves);
      setTotalEntries(response.data.totalEntries); // Assuming totalEntries are provided in response
    } catch (error) {
      console.error("Error fetching leaves:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaves();
  }, [currentPage, searchQuery]); // Fetch leaves when currentPage or searchQuery changes

  // Handle the search input change
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value); // Update the search query state
  };

  // Prevent form default submission behavior and trigger the search
  const handleSearchSubmit = (e) => {
    e.preventDefault(); // Prevent form reload
    setCurrentPage(1); // Reset to the first page when a new search is performed
    fetchLeaves(); // Fetch leaves with the new search query
  };
  const updateLeaveStatus = async (leaveId, status) => {
    try {
      const role = sessionStorage.getItem("role"); // Get role from session storage
      if (!role) {
        console.error("Role is not available in session storage.");
        setShowAlert(true);
        setAlertMessage("Role is not available.");
        setAlertType("error");
        return;
      }

      // Validate the status before sending
      if (!["Approved", "Rejected"].includes(status)) {
        console.error("Invalid status:", status);
        setShowAlert(true);
        setAlertMessage("Invalid status.");
        setAlertType("error");
        return;
      }

      // Validate the leaveId before sending
      if (!leaveId || leaveId.length !== 24) {
        console.error("Invalid leave ID:", leaveId);
        setShowAlert(true);
        setAlertMessage("Invalid leave ID.");
        setAlertType("error");
        return;
      }

      // Send request to update leave status
      const response = await axios.put(
        `https://backend.ems.uk.hiradentallab.com/api/leaves/leave/${leaveId}/status`,
        { status },
        {
          headers: {
            role: role, // Send role in headers to indicate whether the user is an Admin or HR
          },
        }
      );

      // Handle success response
      if (response.status === 200) {
        setShowAlert(true);
        setAlertMessage(`Leave ${status} successfully!`);
        setAlertType("success");

        // Update the leave status in the state
        setLeaves((prevLeaves) =>
          prevLeaves.map((leave) =>
            leave._id === leaveId
              ? {
                  ...leave,
                  status: status,
                  adminAction: response.data.leave.adminAction,
                }
              : leave
          )
        );

        setTimeout(() => setShowAlert(false), 3000); // Hide the alert after 3 seconds
      }
    } catch (error) {
      console.error(
        "Error updating leave status:",
        error.response?.data || error.message
      );
      setShowAlert(true);
      setAlertMessage("Error updating leave status. Please try again.");
      setAlertType("error");
      setTimeout(() => setShowAlert(false), 3000);
    }
  };
  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (
      pageNumber >= 1 &&
      pageNumber <= Math.ceil(totalEntries / rowsPerPage)
    ) {
      setCurrentPage(pageNumber);
    }
  };

  // Calculate page range
  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(totalEntries / rowsPerPage); // Define totalPages here
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const handleShow = (data) => {
    setModalData(data);
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  return (
    <LeaveLayout>
      <div>
        <h1 className="total-leave-header">
          <VscDiffAdded className="total-leave-icon" />
          Total Leave
        </h1>
        <hr />
        <div className="total-leave-content">
          {/* Alert */}
          {showAlert && (
            <div
              className={`alert ${
                alertType === "success" ? "alert-success" : "alert-danger"
              }`}
              role="alert"
            >
              {alertMessage}
            </div>
          )}
          <div>
            <div className="filter-container">
                    <Col xs={12} md={6} className="filter-left">
                      <Dropdown className="d-inline mx-2" autoClose="inside">
                        <Dropdown.Toggle id="dropdown-autoclose-inside">
                          Show Entries
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom-dropdown-menu">
                          <Dropdown.Item href="#">15</Dropdown.Item>
                          <Dropdown.Item href="#">25</Dropdown.Item>
                          <Dropdown.Item href="#">50</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </Col>
                    <Col xs={12} md={6} className="filter-right">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="depts-search-bar"
                      value={searchQuery}
                      onChange={handleSearchChange} // Update search query dynamically
                    />
                  </Form>
                </Col>
                  </div>
          
            <div className="table-responsive">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <table className="table table-striped">
                  <thead className="table-header">
                    <tr className="total-leave-table-header">
                      <th>SR</th>
                      <th>Name</th>
                      <th>Leave Type</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Applied Date</th>
                      <th>Status</th>
                      <th>HR Approval</th>
                      <th>Admin Approval</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {leaves.map((leave, index) => (
                      <tr key={leave._id}>
                        <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                        <td>{leave.name}</td>
                        <td>{leave.leaveType}</td>
                        <td>
                          {new Date(leave.startDate).toLocaleDateString()}
                        </td>
                        <td>{new Date(leave.endDate).toLocaleDateString()}</td>
                        <td>
                          {new Date(leave.appliedDate).toLocaleDateString()}
                        </td>
                        <td>{leave.status}</td>
                        <td>{leave.hrAction}</td>
                        <td>{leave.adminAction}</td>
                        <td>
                          <Button
                            variant="success"
                            size="sm"
                            style={{ marginRight: "10px" }}
                            onClick={() =>
                              updateLeaveStatus(leave._id, "Approved")
                            }
                            disabled={leave.status !== "Pending"}
                          >
                            <FcApproval />
                          </Button>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() =>
                              updateLeaveStatus(leave._id, "Rejected")
                            }
                            disabled={leave.status !== "Pending"}
                          >
                            <TbCalendarCancel />
                          </Button>
                        </td>
                        <td>
                          <div className="action-button">
                            <Link to="/edit-leave">
                              <Button variant="warning" size="sm">
                                <FaEdit />
                              </Button>
                            </Link>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => handleShow(leave)}
                            >
                              <IoEye />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot className="table-footer">
                    <tr className="total-leave-table-footer">
                      <td>Total</td>
                      <td>-</td>
                      <td>{leaves.length}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              )}
            </div>

          <Row className="mt-2">
                            <Col xs={12} md={6} className="d-flex align-items-center">
                              <p className="showing-entries">
                                Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, totalEntries)} of {totalEntries} entries
                              </p>
                            </Col>
                            <Col xs={12} md={6} className="d-flex justify-content-end">
                              <nav>
                                <ul className="pagination">
                                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <a
                                      href="/#"
                                      className="page-link"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handlePageChange(currentPage - 1);
                                      }}
                                    >
                                      Previous
                                    </a>
                                  </li>
                                  {pageRange().map((page) => (
                                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                      <a
                                        href="/#"
                                        className="page-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handlePageChange(page);
                                        }}
                                      >
                                        {page}
                                      </a>
                                    </li>
                                  ))}
                                  <li className={`page-item ${currentPage === Math.ceil(totalEntries / rowsPerPage) ? 'disabled' : ''}`}>
                                    <a
                                      href="/#"
                                      className="page-link"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handlePageChange(currentPage + 1);
                                      }}
                                    >
                                      Next
                                    </a>
                                  </li>
                                </ul>
                              </nav>
                            </Col>
                          </Row>
                        </div>
                      </div>
        {/* Stylish Modal */}
        <Modal
          show={showModal}
          onHide={handleClose}
          centered // Center the modal on the screen
          className="custom-modal"
        >
          <Modal.Header closeButton className="custom-modal-header">
            <Modal.Title>Leave Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modalData && (
              <>
                <p>
                  <strong>Name:</strong> {modalData.name}
                </p>
                <p>
                  <strong>Leave Type:</strong> {modalData.leaveType}
                </p>
                <p>
                  <strong>Start Date:</strong>{" "}
                  {new Date(modalData.startDate).toLocaleDateString()}
                </p>
                <p>
                  <strong>End Date:</strong>{" "}
                  {new Date(modalData.endDate).toLocaleDateString()}
                </p>
                <p>
                  <strong>Applied Duration:</strong> {modalData.appliedDuration}{" "}
                  day(s)
                </p>
                <p>
                  <strong>Applied Date:</strong>{" "}
                  {new Date(modalData.appliedDate).toLocaleDateString()}
                </p>
                <p>
                  <strong>HR Approval:</strong> {modalData.hrApproval}
                </p>
                <p>
                  <strong>Admin Approval:</strong> {modalData.adminApproval}
                </p>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              onClick={handleClose}
              className="custom-modal-btn"
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </LeaveLayout>
  );
}
